export type ReceivedProps = Record<string, any>;

const useCompanyPoliciesCategoryStatus = (props: ReceivedProps) => {
  return {
    ...props,
  };
};

export type Props = ReturnType<typeof useCompanyPoliciesCategoryStatus>;

export default useCompanyPoliciesCategoryStatus;
